export const SUB_OPTIONS_FILTER_LABELS: { [key: string]: string } = {
   RELAXED_MASSAGE: 'missing:types_of_relaxing_massage',
   SENSUAL_MASSAGE: 'missing:types_of_sensual_massages',
   PHYSIOTHERAPY: 'missing:types_of_physiotherapeutic_massage',
};
